import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { toJSDate } from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { Observable } from "rxjs";
import { MaxNumberValidator } from "src/app/directives/max-number.directive";
import { PositiveNumberValidator } from "src/app/directives/positive-number.directive";
import { Divisa } from "src/app/models/Divisa";
import { DetalleDte } from "src/app/models/Dte/DetalleDte";
import { DetalleDteRentencion } from "src/app/models/Dte/DetalleDteRentencion";
import { InvoiceType } from "src/app/models/Dte/invoiceType.enum";
import { OptionsReferenceDteEmitido } from "src/app/models/Dte/OptionsReferenceDteEmitido";
import { OtraMoneda } from "src/app/models/Dte/OtraMoneda";
import { Retencion } from "src/app/models/Dte/Retencion";
import { Impuesto } from "src/app/models/Impuesto";
import { TipoDocumentoReferencia } from "src/app/models/TipoDocRef";
import { TipoDte } from "src/app/models/tipoDte";
import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { ImpuestoService } from "src/app/services/impuesto.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import { DetalleDteImpuestoAdicional } from "../../../../models/Dte/DetalleDteImpuestoAdicional";
import { distinctUntilChanged } from "rxjs/operators";

@Component({
   selector: "[app-item-detalle-documento]",
   templateUrl: "./item-detalle-documento.component.html",
   styleUrls: ["./item-detalle-documento.component.scss"],
})
export class ItemDetalleDocumentoComponent implements OnInit {
   @Input() detalleDte: DetalleDte = new DetalleDte();
   @Input() detalleNumero: number = 0;
   public clpHelperDetalle: DetalleDte = new DetalleDte();
   @Output() deleteDetalle: EventEmitter<any> = new EventEmitter<any>();
   @ViewChild("localDetalleForm") detailForm;
   @ViewChild("currentSwal") private currentSwal: SwalComponent;
   public detalleFormGroup: FormGroup;
   public otraMoneda: OtraMoneda = new OtraMoneda();
   public opciones: OptionsReferenceDteEmitido = new OptionsReferenceDteEmitido();
   private opcionesObservable$: Observable<OptionsReferenceDteEmitido>;
   private divisasObservable$: Observable<Divisa[]>;
   public divisaMessage: string = "Ingresar precio en base a la moneda seleccionada";
   private divisasList: Divisa[] = [];
   private currentEmisorId = this.tokenService.getCompany();
   subPrice: number = 0;
   subtotalForeign: number = 0; //used for holding the type dte of form values in foreing currency
   totalForeign: number = 0;
   totalCurrency: number = 0;
   subDiscount: number = 0;
   subRecharge: number = 0;
   public porcentajeIva: number = environment.taxPercentage;
   public searchCatalog: TipoDocumentoReferencia[] = [];
   public searchLoading: boolean = false;
   public currentTypeDTe: TipoDocumentoReferencia = new TipoDocumentoReferencia();
   private invoiceType$: Observable<InvoiceType>;
   public showingDetails: boolean = true;
   public currentInvoiceType: InvoiceType = InvoiceType.Factura;
   public showRetencionPercent: boolean = false;
   public retencionesSource: Retencion[] = JSON.parse(this.localStorage.getTiposRetenciones()) as Retencion[];
   public tipoDteSource: TipoDocumentoReferencia[] = JSON.parse(this.localStorage.getTipoDocReferencias()) as TipoDocumentoReferencia[];
   constructor(private builder: FormBuilder, private facturador: FacturacionIndividualService, private ref: ChangeDetectorRef, private tokenService: TokenStorageService, private impuestoService: ImpuestoService, private localStorage: LocalStorageService) {
      this.opcionesObservable$ = this.facturador.opcionesReferenciaObservable;
      this.divisasObservable$ = this.facturador.divisasListObservable;
      this.invoiceType$ = this.facturador.currentInvoiceTypeObservable;
   }

   ngOnInit(): void {
      this.tipoDteSource = [...this.tipoDteSource.filter((value, index, array) => array.findIndex((type) => type.codigo === value.codigo) === index)];
      this.createDetalleDteForm();
      this.detalleDteToForm();

      this.opcionesObservable$.subscribe((opciones) => {
         this.opciones = opciones;
         this.onSubmit();
      });
      this.divisasObservable$.pipe(distinctUntilChanged()).subscribe((divisas) => {
         this.divisasList = divisas;
         this.onSubmit();
      });
      this.invoiceType$.subscribe((res) => {
         this.modificationsByInvoiceType(res);
      });
   }
   deleteItem() {
      this.deleteDetalle.emit();
   }

   ngOnChanges() {
   }

   checkFormSubmitted() {
      this.detailForm.nativeElement.submit();
   }
   createDetalleDteForm() {
      this.detalleFormGroup = this.builder.group(
         {
            codigo: [""],
            descripcion: [""],
            cantidad: [this.detalleDte.cantidad ? this.detalleDte.cantidad : 1, [Validators.required, PositiveNumberValidator]],
            unidadMedida: [""],
            precioUnitario: [0, [Validators.required]],
            descuento: [0, [Validators.min(0)]],
            recargo: [0, [Validators.min(0)]],
            exento: [false],
            subtotal: [""],
            haveCodigo: [false],
            nombreItem: [, { validators: Validators.required }],
            haveRetencion: [false],
            retencionPorcentaje: [19, [MaxNumberValidator(this.porcentajeIva * 100)]],
            retencionTipo: [this.retencionesSource[0]],
         },
         { updateOn: "blur" }
      );
   }

   onSubmit() {
      this.ref.detectChanges();
      if (this.detalleFormGroup.valid) {
         this.detalleDte.codigoInterno = this.detalleFormGroup.controls.codigo.value;
         this.detalleDte.descripcion = this.detalleFormGroup.controls.descripcion.value?.trim() || null;
         this.detalleDte.nombre = this.detalleFormGroup.controls.nombreItem.value;
         this.detalleDte.cantidad = this.detalleFormGroup.controls.cantidad.value;
         this.detalleDte.unidadMedida = this.detalleFormGroup.controls.unidadMedida.value?.trim() || null;
         this.detalleDte.esExento = this.detalleFormGroup.controls.exento.value;

         // if ((!this.detalleDte.esExento && this.detalleDte.codigoInterno == "34") || this.detalleDte.codigoInterno == "41") {
         //    this.detalleFormGroup.controls.exento.setValue(true);
         // }
         // if ((this.detalleDte.esExento && this.detalleDte.codigoInterno == "33") || this.detalleDte.codigoInterno == "39") {
         //    this.detalleFormGroup.controls.exento.setValue(false);
         // }
         this.ref.detectChanges();
         this.detalleDte.precioUnitario = this.detalleFormGroup.controls.precioUnitario.value;
         this.detalleDte.descuento = this.detalleFormGroup.controls.descuento.value ?? 0;
         this.detalleDte.recargo = this.detalleFormGroup.controls.recargo.value ?? 0;
         this.detalleDte.subtotal = this.detalleDte.precioUnitario * this.detalleDte.cantidad;
         let subMasCargos = this.detalleDte.recargo ? this.detalleDte.subtotal + this.detalleDte.recargo : this.detalleDte.subtotal;
         this.detalleDte.total = this.detalleDte.descuento ? subMasCargos - this.detalleDte.descuento : subMasCargos;
         this.ref.detectChanges();
         this.facturador.updateItem(this.detalleDte);
      }
   }

   getRetencionChanges($event: Retencion) {
      if (this.currentInvoiceType == 3) {
         this.detalleDte.retenciones = [];
         let retencion = new DetalleDteRentencion();
         let selectedRetencion: Retencion = $event;
         retencion.codigoSii = selectedRetencion.codigoSii;
         retencion.valor = selectedRetencion.tasaDefecto;
         retencion.nombreRetencion = selectedRetencion.nombre;
         this.detalleFormGroup.controls.retencionPorcentaje.patchValue(retencion.valor);
         this.detalleDte.retenciones.push(retencion);
      }
      this.onSubmit();
   }
   exchangeBasedCalculation() {
      //work with de selected rate of exchange to CLP and show the values under the input tags
      if (this.opciones.tipoMoneda && this.opciones.tipoMoneda != "") {
      }
   }

   public adicionalesAbiertos = false;

   changeHaveCodigo(event) {
      this.ref.detectChanges();
      this.detalleFormGroup.controls.haveCodigo.patchValue(event.target.checked);
   }

   searchItem(event, propertyName) {
      this.searchLoading = true;
      this.searchCatalog = [...this.tipoDteSource] as TipoDocumentoReferencia[];
      this.ref.detectChanges();
      this.searchLoading = false;
   }
   refreshItemDetail(event: TipoDocumentoReferencia) {
      //set selected item to form
      this.currentTypeDTe = event;
      if (event && event.codigo) {
         this.selectedTypeDteToForm(this.currentTypeDTe);
      }
      this.onSubmit();
   }

   selectedTypeDteToForm(selectedTypeDte: TipoDocumentoReferencia) {
      if (selectedTypeDte) {
         this.detalleFormGroup.controls.codigo.patchValue(selectedTypeDte.codigo);
         this.detalleFormGroup.controls.nombreItem.patchValue(selectedTypeDte.nombre);
      }
   }

   modificationsByInvoiceType(type: InvoiceType) {
      this.currentInvoiceType = type;
      switch (type) {
         case InvoiceType.Boleta: {
            this.showingDetails = false;
            break;
         }
         case InvoiceType.Factura: {
            this.showingDetails = true;
            break;
         }
         case InvoiceType.GuiaDespacho: {
            this.showingDetails = true;
            break;
         }
         case InvoiceType.LiquidacionFactura: {
            this.showingDetails = true;
            break;
         }
      }
   }

   calculateTaxesInItem() {
      let taxAmount = 0;
      if (this.detalleDte.impuestosAdicionales != undefined) {
         taxAmount = this.detalleDte.impuestosAdicionales.reduce((acc, curr) => acc + curr.valor, 0);
      }
      return taxAmount;
   }

   changeRetencionInput($event) {
      this.ref.detectChanges();
      this.detalleFormGroup.controls.haveRetencion.patchValue($event.target.checked);
      this.showRetencionPercent = this.detalleFormGroup.controls.haveRetencion.value;
   }

   detalleDteToForm() {
      this.detalleFormGroup.controls.codigo.patchValue(this.detalleDte.codigoInterno);
      this.detalleFormGroup.controls.nombreItem.patchValue(this.detalleDte.nombre);
      this.detalleFormGroup.controls.descripcion.patchValue(this.detalleDte.descripcion);
      this.detalleFormGroup.controls.cantidad.patchValue(this.detalleDte.cantidad || 1);
      this.detalleFormGroup.controls.subtotal.patchValue(this.detalleDte.total);
      this.detalleFormGroup.controls.exento.patchValue(this.detalleDte.esExento);
      this.detalleFormGroup.controls.precioUnitario.patchValue(this.detalleDte.precioUnitario);
      this.detalleFormGroup.controls.descuento.patchValue(this.detalleDte.descuento);
      this.detalleFormGroup.controls.recargo.patchValue(this.detalleDte.recargo);
      this.adicionalesAbiertos = !!this.detalleDte.descripcion?.trim() || this.detalleDte.descuento > 0 || this.detalleDte.recargo > 0;
    
      this.ref.detectChanges();
    }
    
}
